/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import {
  FormPage,
  theme,
  ProgressBarPagePosition,
  ProgressBarPageCount,
} from 'shared';

const { smallAndUp, lessThanSmall } = theme.BREAKPOINTS;

export type ProgressBarProps = Partial<
  Pick<FormPage, 'design' | 'progressBar'>
>;

export const ProgressBarWrapper = styled.div`
  @media (${smallAndUp}) {
    padding: 0 24px;
  }
  @media (${lessThanSmall}) {
    padding: 0 12px;
  }
  margin-top: 24px;
  label: Wrapper;
`;

export const ProgressBar: React.FC<ProgressBarProps> = (props) => {
  const { design, progressBar } = props;
  const {
    progressBarBackground = '',
    progressBarFont = '',
    progressBarBackgroundCurrentPage = '',
    progressBarFontCurrentPage = '',
  } = design?.colors || {};

  if (!progressBar) {
    return null;
  }
  return (
    <ProgressBarWrapper>
      {progressBar.type === 'pagePosition' && (
        <ProgressBarPagePosition
          labels={progressBar.pageLabels}
          currentPage={progressBar.currentPage}
          progressBarBackground={progressBarBackground}
          progressBarFont={progressBarFont}
          progressBarBackgroundCurrentPage={progressBarBackgroundCurrentPage}
          progressBarFontCurrentPage={progressBarFontCurrentPage}
        />
      )}
      {progressBar.type === 'pageCount' && (
        <ProgressBarPageCount
          type={progressBar.type}
          currentPageCount={progressBar.currentPageCount}
          totalPageCount={progressBar.totalPageCount}
        />
      )}
      {progressBar.type === 'pagePercentage' && (
        <ProgressBarPageCount
          type={progressBar.type}
          currentPageCount={progressBar.currentPageCount}
          totalPageCount={progressBar.totalPageCount}
        />
      )}
    </ProgressBarWrapper>
  );
};
